export default __webpack_public_path__ + "media/titles/title_3_locale_pt-d1c39ece.png";